import { render, staticRenderFns } from "./Teeth.vue?vue&type=template&id=29f2f802&scoped=true"
import script from "./Teeth.vue?vue&type=script&lang=js"
export * from "./Teeth.vue?vue&type=script&lang=js"
import style0 from "./Teeth.vue?vue&type=style&index=0&id=29f2f802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2f802",
  null
  
)

export default component.exports